import { Pipe, PipeTransform } from '@angular/core';
import { LinkedAccountStatusesEnum } from '@spa/api';
import { Helper } from '../classes';
import { LanguageService } from '../language.service';

@Pipe({
  name: 'linkedAccountStatus',
  pure: true
})
export class LinkedAccountStatusPipe implements PipeTransform {
  constructor(private languageService: LanguageService) {
  }

  transform(value: LinkedAccountStatusesEnum): string {
    const language = this.languageService.getCurrentLanguage();

    return Helper.textsHelper().getLinkedAccountStatusName(value, language);
  }
}
